@if (!shop) {
  <div class="card card-shop">
    <div class="card-background"></div>
  </div>
}

@if (shop) {
  <div class="card card-shop" (click)="onCardClick($event)">
    <div
      class="card-background"
      [lazyLoad]="shop.photo?.url1x ? shop.photo?.url1x + '?w=480&h=480&m=2' + addWebp : ''"
    ></div>
    <div class="card-body" [ngStyle]="{ 'margin-bottom': '-' + hiddenPart.offsetHeight + 'px' }">
      <div
        class="card-title dot"
        [ngStyle]="{ 'margin-bottom': (shop.street && shop.city) || shop.description ? '' : '10px' }"
      >
        <span>{{ shop.name }}</span>
      </div>
      @if (shop.street && shop.city) {
        <div class="card-address">
          <span class="address-icon" [inlineSVG]="'/icons/icon-address.svg'"></span>
          {{ shop.street }}{{ shop.house_number ? ' ' + shop.house_number : '' }}, {{ shop.city }}
        </div>
      }
      <div #hiddenPart class="xs-hide sm-hide md-hide">
        @if (shop.description) {
          <div class="card-description" [innerHTML]="shop.description"></div>
        }
        <a [routerLink]="['/bedrijf', shop.permalink]" class="btn btn-card xs-hide sm-hide md-hide">
          {{ 'global.open' | transloco }}
        </a>
      </div>
    </div>
  </div>
}
